import React from 'react';
import { scroller } from 'react-scroll';
import styled from 'styled-components';
import { PaddedContainer, SectionName, SmallButton } from '../common/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  padding-top: ${props => (props.theme.isMobile ? '80px' : '104px')};
  padding-bottom: ${props => (props.theme.isMobile ? '80px' : '104px')};
  background-image: ${props => `url(${props.theme.isMobile ? props.theme.heroPortrait : props.theme.hero})`};
  background-size: cover;
  background-position: center;
  border-bottom-right-radius: ${props => (props.theme.isMobile ? '200px' : '180px')};
`;

const SectionNameExt = styled(SectionName)`
  color: white;
  font-size: 16px;
  line-height: 1.5;
`;

const Desc = styled.p`
  position: relative;
  margin: 0;
  color: white;
  font-weight: 700;
  ${props => (props.theme.isMobile ? `
    font-size: 48px;
    line-height: 56px;
  ` : `
    max-width: 800px;
    font-size: 64px;
    line-height: 72px;
  `)};
`;

const SubDesc = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 18px;
  color: white;
  margin-top: 12px;
  margin-bottom: 24px;
  max-width: 740px;
`;

const Button = styled(SmallButton)`
  background-color: #183AD9;
  width: 130px;

  &:hover {
    background-color: #19202D;
  }
`;

export default function Hero() {
  const scrollToGetInTouchForm = () => scroller.scrollTo('get_in_touch', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return (
    <Container>
      <PaddedContainer>
        <SectionNameExt>Partner with us</SectionNameExt>
        <Desc>Connect with Australia’s most engaged investors</Desc>
        <SubDesc>
          Access our network’s high-quality audience of self-directed and high-net-worth investors,
          wealth advisers, consultants, fund managers, and institutional investors.
        </SubDesc>
        <Button onClick={scrollToGetInTouchForm}>Get in touch</Button>
      </PaddedContainer>
    </Container>
  );
}
